import React, { useEffect, useRef, useState } from 'react'
import { Button } from 'react-bootstrap'
import { token } from '@bigyellow/api/auth'
import { handle_api_exception } from '../api/exception'
import EnterAppAuthCodeForm from '@bigyellow/components/SignIn/EnterAppAuthCodeForm'
import EnterMobileCodeForm from '@bigyellow/components/SignIn/EnterMobileCodeForm'
import useResendCooldown from '@bigyellow/libs/useResendCooldown'

const MfaAuth = ({
    onVerifiedSuccess,
    onCancelVerification,
    reSendVerificationCode,
    store,
    authCredentials,
}) => {
    const [isVerifying, setVerifying] = useState(false);
    const codeInputField = useRef(null)

    const RESEND_COOLDOWN_SECONDS = 60;
    const { secondsLeft, isCoolingDown, start: startResendCooldown } = useResendCooldown(RESEND_COOLDOWN_SECONDS);

    // auto focus on input field
    useEffect(()=>{
        if(codeInputField && codeInputField.current) {
            codeInputField.current.focus();
        }
    },[codeInputField])

    // If SMS MFA is being used, start a cooldown immediately (a code is typically sent on entry).
    useEffect(() => {
        if (authCredentials?.sms) {
            startResendCooldown(RESEND_COOLDOWN_SECONDS);
        }
    }, [authCredentials?.sms, startResendCooldown]);

    const onClickResend = async (e) => {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        if (isVerifying || isCoolingDown) return;

        startResendCooldown(RESEND_COOLDOWN_SECONDS);

        try {
            if (typeof reSendVerificationCode === 'function') {
                await reSendVerificationCode();
            }
        } catch (err) {
            const notify = store ? store.get('notify') : null;
            if (notify) {
                notify(handle_api_exception(err), { type: 'error' });
            }
        }
    }

    const verifyCode = (inCode) => {
        setVerifying(true);

        const http_client = store ? store.get('http_client') : null;
        const notify = store ? store.get('notify') : null;
        const { email, password } = authCredentials;
        const payload = {
            email: email,
            password: password,
            code: inCode,
        };

        token(http_client, payload)
            .then((res) => {
                const { data, code } = res.data;
                if (code === 200) {
                    onVerifiedSuccess(data);
                } else {
                    alert('Oooops. There was a problem.');
                }
            })
            .catch((err) => {
                if (notify) {
                    notify(handle_api_exception(err), {type: 'error'});
                }
                // onVerifiedSuccess(false);
            }).finally(()=>{
                setVerifying(false);
            });

    };

    return (
        <React.Fragment>
            <i
                className={`lni lni-close icon close`}
                onClick={onCancelVerification}
            />
            <div className={'text-center pt-5'}>
                    {
                        authCredentials.sms &&<EnterMobileCodeForm debugCode={authCredentials.debugCode} phoneEnd={authCredentials.phoneEnd} disabled={isVerifying}  onComplete={verifyCode} />

                    }
                    {
                        authCredentials.totp &&<EnterAppAuthCodeForm disableScan={true} isDisabled={isVerifying} onEnteredValidCode={verifyCode} />
                    }


                { authCredentials.sms &&
                <Button
                    variant="link"
                    onClick={onClickResend}
                    disabled={isVerifying || isCoolingDown}
                    aria-disabled={isVerifying || isCoolingDown}
                >
                    {isCoolingDown ? `Resend in ${secondsLeft}s` : 'Resend verification code'}
                </Button>}
            </div>
        </React.Fragment>
    );
};

export {  MfaAuth };
